export const WaitingForAuthorization = {
    Message: "Please wait while we authorize your card."
}


// WEBPACK FOOTER //
// ./src/localization/WaitingForAuthorization.ts